import { ObservableResult } from '../../models/result.model';
import { LeadsDataService, LeadsPageInfo } from './leads-data.service';
import {
  Ausschreibungstextes,
  Broschures, CadDatens,
  CheckDuplicateContact, FatcsStatus, ConstructionTypes,
  CreateLead, EmailData, ExtendedProperties, IAddressData,
  IContact,
  LeadData, LeadDocumentsModel,
  LeadsData, LeadsDataAction, LeadsHistory,
  LeadsQueryRequest,
  LeadSources, LeadStatus,
  LeadType, Musters, SolveDuplicateContact,
  Articles, Keyword, ImportComposerLeadRequest,
  ImportComposerLeadResponse
} from '../../models/leads/leads.model';

export class MockLeadsDataService implements LeadsDataService {

  leadData: any = {
    "Contact": {
      "Id": 2080,
      "ContactTypeId": 3,
      "ContactMethodId": 2,
      "FirstName": "Arsh",
      "LastName": "A",
      "Address": "German",
      "Email": "",
      "Phone": "5564646",
      "PhonePrefix": "32",
      "LanguageCode": "de",
      "TaxNumber": "fsdfsfs",
      "Anonymized": false,
      "SalutationId": 3,
      "ConsentMarketing": false,
      "ConsentThirdParties": false,
      "ContactTypeText": "Private client",
      "ContactMethodText": "Phone",
      "ContactMethodName": "TELEFON",
      "LanguageText": "German",
      "SalutationText": "Mr.",
      "Inactive": false,
      "CreTS": "2022-03-09T10:48:11Z",
      "ModTS": "2024-11-28T09:57:18Z"
    },
    "Editor": {
      "Id": 3,
      "Login": "jfritz",
      "FirstName": "Juliane",
      "LastName": "Fritz",
      "Organisation": "Digital Customer Experience",
      "Email": "JFritz@finstral.com",
      "Phone": "+39 0471296611",
      "LanguageCode": "en",
      "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/3?ts=1746195106",
      "Available": true,
      "Inactive": false,
      "NotificationsEnabled": false,
      "AppointmentMailEnabled": false,
      "ExternalMailCCEnabled": true,
      "CompletedMailEnabled": true,
      "LeadMailEnabled": false,
      "EnableReporting": true,
      "LastActivity": "2025-05-02T14:28:22Z"
    },
    "Creator": {
      "Id": 285,
      "Login": "otto.kreidl@zeppelin-group.com",
      "FirstName": "Otto",
      "LastName": "Kreidl",
      "Organisation": "Administrator WGLF",
      "Email": "syuzannasargsyan753@gmail.com",
      "Phone": "+351 987654321",
      "LanguageCode": "en",
      "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/285?ts=1732703703",
      "Available": true,
      "Inactive": false,
      "NotificationsEnabled": false,
      "AppointmentMailEnabled": false,
      "ExternalMailCCEnabled": true,
      "CompletedMailEnabled": true,
      "LeadMailEnabled": false,
      "EnableReporting": true,
      "LastActivity": "2025-01-10T08:53:10Z"
    },
    "PrivacyDate": "2022-03-09T10:48:13Z",
    "PrivacyText": "Ja",
    "Actions": [
      {
        "Id": 49,
        "Name": "LEAD_FORWARD",
        "Label": "Assign enquiry",
        "Hidden": false,
        "Suggested": true
      },
      {
        "Id": 182,
        "Name": "LEAD_FORWARD_EXT",
        "Label": "Assign lead externally",
        "Hidden": true,
        "Suggested": false
      },
      {
        "Id": 122,
        "Name": "LEAD_TYPE",
        "Label": "Edit enquiry type",
        "Hidden": false,
        "Suggested": false
      },
      {
        "Id": 56,
        "Name": "LEAD_REMINDER",
        "Label": "Put on hold",
        "Hidden": false,
        "Suggested": false
      },
      {
        "Id": 53,
        "Name": "LEAD_NOT_INTERESTED",
        "Label": "Cancel enquiry(ies)",
        "Hidden": false,
        "Suggested": false
      },
      {
        "Id": 883,
        "Name": "LEAD_CONNECT",
        "Label": "Link enquiry",
        "Hidden": false,
        "Suggested": false
      }
    ],
    "CanDelete": false,
    "ConnectedContacts": [
      {
        "Id": 2186,
        "CountryText": "DE",
        "Email": 'test@test.test',
        "FirstName": 'Test 1',
        "LastName": 'LAST',
      },
      {
        "Id": 2185,
        "CountryText": "DE",
        "Email": 'test@test2.test',
        "FirstName": 'Test 2',
        "LastName": 'LAST',
      }
    ],
    "AllLeads": [
      {
        "Id": 2187,
        "Number": "20220309001",
        "LeadTypeId": 44,
        "StatusId": 2,
        "EditorId": 3,
        "CreatorId": 285,
        "LeadText": "gfhg",
        "LeadSourceId": 10,
        "Contact": {
          "Id": 2080,
          "Email": "otto.kreidl-2080@temp.finstral.com",
          "FirstName": "Arsh",
          "LastName": "A",
          "TaxNumber": "fsdfsfs",
          "SalutationText": "Mr.",
          "Address": "German",
          "Phone": "5564646",
          "PhonePrefix": "32",
          "Anonymized": false,
          "LanguageCode": "de",
          "ContactTypeId": 3,
          "ContactMethodId": 2,
          "Inactive": false
        },
        "ConstructionTypeId": 1,
        "LeadTypeText": "Product advice",
        "StatusText": "Enquiry rejected",
        "Done": false,
        "LeadSourceText": "E-mail",
        "EditorName": "Fritz Juliane",
        "CreatorName": "Kreidl Otto",
        "ExternalEmail": "f@ddd.com",
        "Address": {},
        "ConsentAccredation": false,
        "RequiresConfirmation": false,
        "Read": true,
        "VisibilityRule": "is owner",
        "LimitedAccess": false,
        "LastChange": "2025-04-17T10:16:05Z",
        "LastAction": "LEAD_REJECT",
        "LastEditorId": 21815,
        "LastEditorName": "Contacts Service User",
        "UTMParameters": {},
        "CreTS": "2022-03-09T10:48:11Z",
        "ModTS": "2025-05-01T22:30:23Z",
        "DateFormattedId": "09.03.2022/001"
      }
    ],
    "ConnectedLeads": [],
    "Articles": [],
    "Events": [],
    "CompanyContacts": [
      {
        "Id": 2186,
        "CountryText": "DE",
        "Email": 'test@test.test',
        "FirstName": 'Test 1',
        "LastName": 'LAST',
      },
      {
        "Id": 2185,
        "CountryText": "DE",
        "Email": 'test@test2.test',
        "FirstName": 'Test 2',
        "LastName": 'LAST',
      }
    ],
    "Lead": {
      "Id": 2187,
      "Number": "20220309001",
      "LeadTypeId": 44,
      "StatusId": 2,
      "EditorId": 3,
      "CreatorId": 285,
      "LeadText": "gfhg",
      "LeadSourceId": 10,
      "Contact": {
        "Id": 2080,
        "Email": "otto.kreidl-2080@temp.finstral.com",
        "FirstName": "Arsh",
        "LastName": "A",
        "TaxNumber": "fsdfsfs",
        "SalutationText": "Mr.",
        "Address": "German",
        "Phone": "5564646",
        "PhonePrefix": "32",
        "Anonymized": false,
        "LanguageCode": "de",
        "ContactTypeId": 3,
        "ContactMethodId": 2,
        "Inactive": false
      },
      "ConstructionTypeId": 1,
      "LeadTypeText": "Product advice",
      "StatusText": "Enquiry rejected",
      "Done": false,
      "LeadSourceText": "E-mail",
      "EditorName": "Fritz Juliane",
      "CreatorName": "Kreidl Otto",
      "ExternalEmail": "f@ddd.com",
      "Address": {},
      "ConsentAccredation": false,
      "RequiresConfirmation": false,
      "Read": true,
      "VisibilityRule": "is owner",
      "LimitedAccess": false,
      "LastChange": "2025-04-17T10:16:05Z",
      "LastAction": "LEAD_REJECT",
      "LastEditorId": 21815,
      "LastEditorName": "Contacts Service User",
      "UTMParameters": {},
      "CreTS": "2022-03-09T10:48:11Z",
      "ModTS": "2025-05-01T22:30:23Z",
      "DateFormattedId": "09.03.2022/001"
    },
    "IsAppointment": false,
    "SuggestedAction": {
      "Id": 49,
      "Name": "LEAD_FORWARD",
      "Label": "Assign enquiry",
      "Hidden": false,
      "Suggested": true
    },
    "Messages": [],
    "Keywords": [
      "gfhghdfhdf",
      "Keyword3"
    ]
  };

  leadsData: any[] = [
    {
      "ConnectedContacts": [
        {
          "Id": 2186,
          "CountryText": "DE",
          "Email": 'test@test.test',
          "FirstName": 'Test 1',
          "LastName": 'LAST',
        },
        {
          "Id": 2185,
          "CountryText": "DE",
          "Email": 'test@test2.test',
          "FirstName": 'Test 2',
          "LastName": 'LAST',
        }
      ],
      "Lead": {
        "Id": 2187,
        "Number": "20220309001",
        "LeadTypeId": 44,
        "StatusId": 2,
        "EditorId": 3,
        "CreatorId": 285,
        "LeadText": "gfhg",
        "LeadSourceId": 10,
        "Contact": {
          "Id": 2080,
          "Email": "otto.kreidl-2080@temp.finstral.com",
          "FirstName": "Arsh",
          "LastName": "A",
          "TaxNumber": "fsdfsfs",
          "SalutationText": "Mr.",
          "Address": "German",
          "Phone": "5564646",
          "PhonePrefix": "32",
          "Anonymized": false,
          "LanguageCode": "de",
          "ContactTypeId": 3,
          "ContactMethodId": 2,
          "Inactive": false
        },
        "ConstructionTypeId": 1,
        "LeadTypeText": "Product advice",
        "StatusText": "Enquiry rejected",
        "Done": false,
        "LeadSourceText": "E-mail",
        "EditorName": "Fritz Juliane",
        "CreatorName": "Kreidl Otto",
        "ExternalEmail": "f@ddd.com",
        "Address": {},
        "ConsentAccredation": false,
        "RequiresConfirmation": false,
        "Read": true,
        "LimitedAccess": false,
        "LastChange": "2025-04-17T10:16:05Z",
        "LastAction": "LEAD_REJECT",
        "LastEditorId": 21815,
        "LastEditorName": "Contacts Service User",
        "UTMParameters": {},
        "CreTS": "2022-03-09T10:48:11Z",
        "ModTS": "2025-05-01T22:30:23Z",
        "DateFormattedId": "09.03.2022/001"
      },
      "IsAppointment": false,
      "SuggestedAction": {
        "Id": 49,
        "Name": "LEAD_FORWARD",
        "Label": "Assign enquiry",
        "Hidden": false,
        "Suggested": true
      },
      "Keywords": [
        "gfhghdfhdf",
        "Keyword3"
      ]
    }
  ];

  leadType: LeadType = {
    Id: 1,
    Name: "New Lead",
    Description: "A new lead created from a marketing campaign.",
    Inactive: false,
    SortOrder: 1,
    IsGeneral: true
  };

  leadStatus: LeadStatus = {
    Id: 2,
    Success: true,
    Initial: false,
    Completed: false,
    DeadlineHours: 48,
    DeadlineSuccessorId: 3,
    SortOrder: 1,
    Text: "Lead in Progress"
  };

  leadSource: LeadSources = {
    Id: 5,
    Name: "Website",
    Description: "Leads generated from the website contact form.",
    FinstralOnly: true,
    SortOrder: 1,
    Inactive: true
  };

  extendedProperties: ExtendedProperties = {
    PLANER_CODE: "PC1234",
    OFFER_AMOUNT: 5000.00,
    OFFER_CURRENCY: "USD",
    OFFER_NUMBER: "OFFER001234",
    ORDER_AMOUNT: 4500.00,
    ORDER_CURRENCY: "USD",
    ORDER_NUMBER: 98765,
    CUSTOMER: "John Doe",
    COMPOSER_CUSTOMER: "Jane Smith"
  };

  brochures: Broschures[] = [
    {
      key: "B-1167111",
      title: "F_03 - Framing Light",
      img: "https://cdn.finstral.com/images/content/1256303_53124_1_C_100_100_0_202941767/finstral-prospekt-gedreht-233x300-de.png",
      ordernumber: "61-0803-00-01"
    },
    {
      key: "B-1167113",
      title: "Fenster Glaswände",
      img: "https://cdn.finstral.com/images/content/1187689_53124_1_C_100_100_0_296183570/finstral-fenster-glaswände.png",
      ordernumber: "61-1000-00-01"
    },
  ]

  ausschreibungs: Ausschreibungstextes[] = [
    {
      key: "W-1236673",
      title: "FIN-Window Classic-line 77 - Kunststoff-Kunststoff",
      img: "https://cdn.finstral.com/images/content/1236673_53151_1_C_100_100_0_111664184/finstral-fin-window-classic-line-77-kunststoff-kunststoff.png",
      ordernumber: "61-0803-00-01"
    },
    {
      key: "W-1236687",
      title: "FIN-Window Nova-line 77 - Kunststoff-Kunststoff",
      img: "https://cdn.finstral.com/images/content/1236687_53151_1_C_100_100_0_111666711/finstral-fin-window-nova-line-77-kunststoff-kunststoff.png",
      ordernumber: "61-1000-00-01"
    },
  ];

  cadData: CadDatens[] = [
    {
      key: "W-1236836",
      title: "FIN-Window Nova-line Plus N 90+8 - Aluminium-Kunststoff",
      img: "https://cdn.finstral.com/images/content/1236836_53151_1_C_100_100_0_111683885/finstral-fin-window-nova-line-plus-n-90-8-aluminium-kunststoff.png",
      ordernumber: "61-0803-00-01"
    },
    {
      key: "W-1236837",
      title: "FIN-Window Nova-line Twin C 90+8 - Aluminium-Kunststoff",
      img: "https://cdn.finstral.com/images/content/1236837_53151_1_C_100_100_0_111684162/finstral-fin-window-nova-line-twin-c-90-8-aluminium-kunststoff.png",
      ordernumber: "61-1000-00-01"
    },
  ]

  muster: Musters[] = [
    {
      key: "W-1236673",
      title: "FIN-Window Classic-line 77 - Kunststoff-Kunststoff",
      img: "https://cdn.finstral.com/images/content/1236673_53151_1_C_100_100_0_111664184/finstral-fin-window-classic-line-77-kunststoff-kunststoff.png",
    },
    {
      key: "W-1236687",
      title: "FIN-Window Nova-line 77 - Kunststoff-Kunststoff",
      img: "https://cdn.finstral.com/images/content/1236687_53151_1_C_100_100_0_111666711/finstral-fin-window-nova-line-77-kunststoff-kunststoff.png",
    },
  ]

  history: any[] = [
    {
      "Id": 63491,
      "LeadId": 2187,
      "ActionId": 50,
      "LeadEditorId": 3,
      "RejectReasonId": 663,
      "LeadTypeId": 44,
      "LeadStateId": 2,
      "ExternalEmail": "f@ddd.com",
      "LeadNumber": "20220309001",
      "ActionName": "LEAD_REJECT",
      "ActionText": "Reject enquiry",
      "RejectReasonText": "Inaktivität (Ablauf der Deadline)",
      "LeadTypeText": "Product advice",
      "LeadStateText": "Enquiry rejected",
      "LeadStateName": "REJECTED",
      "CreTs": "2025-04-17T10:16:05Z",
      "CreatorId": 21815,
      "Creator": {
        "Id": 21815,
        "FirstName": "Service User",
        "LastName": "Contacts",
        "Organisation": "Central IT Administration",
        "LanguageCode": "de",
        "AvatarURL": "https://www.gravatar.com/avatar/a5fe32e14b8a06809010dead5cd76fcc?r=g&d=identicon&s=60",
        "Login": "contacts-service@finstral.com",
        "Available": true,
        "Inactive": false,
        "NotificationsEnabled": false,
        "AppointmentMailEnabled": false,
        "ExternalMailCCEnabled": true,
        "CompletedMailEnabled": false,
        "LeadMailEnabled": false,
        "EnableReporting": true
      },
      "LeadEditor": {
        "Id": 3,
        "Login": "jfritz",
        "FirstName": "Juliane",
        "LastName": "Fritz",
        "Organisation": "Digital Customer Experience",
        "Email": "JFritz@finstral.com",
        "Phone": "+39 0471296611",
        "LanguageCode": "en",
        "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/3?ts=1746195106",
        "Available": true,
        "Inactive": false,
        "NotificationsEnabled": false,
        "AppointmentMailEnabled": false,
        "ExternalMailCCEnabled": true,
        "CompletedMailEnabled": true,
        "LeadMailEnabled": false,
        "EnableReporting": true,
        "LastActivity": "2025-05-02T14:28:22Z"
      },
      "Documents": [],
      "ComposerChanges": []
    },
    {
      "Id": 63465,
      "LeadId": 2187,
      "ActionId": 49,
      "LeadEditorId": 21903,
      "LeadTypeId": 44,
      "LeadStateId": 103,
      "Deadline": "2025-04-17T10:15:07Z",
      "ExternalEmail": "f@ddd.com",
      "LeadNumber": "20220309001",
      "ActionName": "LEAD_FORWARD",
      "ActionText": "Assign enquiry",
      "LeadTypeText": "Product advice",
      "LeadStateText": "In assignment",
      "LeadStateName": "ASSIGNING",
      "CreTs": "2025-04-16T10:15:07Z",
      "CreatorId": 3,
      "Creator": {
        "Id": 3,
        "Login": "jfritz",
        "FirstName": "Juliane",
        "LastName": "Fritz",
        "Organisation": "Digital Customer Experience",
        "Email": "JFritz@finstral.com",
        "Phone": "+39 0471296611",
        "LanguageCode": "en",
        "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/3?ts=1746195106",
        "Available": true,
        "Inactive": false,
        "NotificationsEnabled": false,
        "AppointmentMailEnabled": false,
        "ExternalMailCCEnabled": true,
        "CompletedMailEnabled": true,
        "LeadMailEnabled": false,
        "EnableReporting": true,
        "LastActivity": "2025-05-02T14:28:22Z"
      },
      "LeadEditor": {
        "Id": 21903,
        "Login": "4TEST-01@finstral.cloud",
        "FirstName": "Jeanne",
        "LastName": "Dupont",
        "Organisation": "Contact Manager store 4TEST",
        "Email": "cloud@finstral.com",
        "LanguageCode": "en",
        "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/21903?ts=1745995829",
        "Available": true,
        "Inactive": false,
        "NotificationsEnabled": false,
        "AppointmentMailEnabled": false,
        "ExternalMailCCEnabled": false,
        "CompletedMailEnabled": false,
        "LeadMailEnabled": false,
        "EnableReporting": true,
        "LastActivity": "2025-05-02T14:18:06Z"
      },
      "Documents": [],
      "ComposerChanges": []
    },
    {
      "Id": 53681,
      "LeadId": 2187,
      "ActionId": 82,
      "Comment": "<a target=\"_blank\" href=\"https://finstral-contacts-api.armdev.am/\">link</a>",
      "LeadEditorId": 3,
      "LeadTypeId": 44,
      "LeadStateId": 83,
      "Deadline": "2022-03-10T10:48:11Z",
      "ExternalEmail": "f@ddd.com",
      "LeadNumber": "20220309001",
      "ActionName": "COMMENT_CREATE",
      "ActionText": "Create comment",
      "LeadTypeText": "Product advice",
      "LeadStateText": "Enquiry externally assigned",
      "LeadStateName": "ASSIGNED_EXT",
      "CreTs": "2024-11-28T09:54:54Z",
      "CreatorId": 3,
      "Creator": {
        "Id": 3,
        "Login": "jfritz",
        "FirstName": "Juliane",
        "LastName": "Fritz",
        "Organisation": "Digital Customer Experience",
        "Email": "JFritz@finstral.com",
        "Phone": "+39 0471296611",
        "LanguageCode": "en",
        "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/3?ts=1746195106",
        "Available": true,
        "Inactive": false,
        "NotificationsEnabled": false,
        "AppointmentMailEnabled": false,
        "ExternalMailCCEnabled": true,
        "CompletedMailEnabled": true,
        "LeadMailEnabled": false,
        "EnableReporting": true,
        "LastActivity": "2025-05-02T14:28:22Z"
      },
      "LeadEditor": {
        "Id": 3,
        "Login": "jfritz",
        "FirstName": "Juliane",
        "LastName": "Fritz",
        "Organisation": "Digital Customer Experience",
        "Email": "JFritz@finstral.com",
        "Phone": "+39 0471296611",
        "LanguageCode": "en",
        "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/3?ts=1746195106",
        "Available": true,
        "Inactive": false,
        "NotificationsEnabled": false,
        "AppointmentMailEnabled": false,
        "ExternalMailCCEnabled": true,
        "CompletedMailEnabled": true,
        "LeadMailEnabled": false,
        "EnableReporting": true,
        "LastActivity": "2025-05-02T14:28:22Z"
      },
      "Documents": [],
      "ComposerChanges": []
    },
    {
      "Id": 53680,
      "LeadId": 2187,
      "ActionId": 82,
      "Comment": "<a target=\"_blank\" href=\"https://finstral-contacts-api.armdev.am/details/17962\">Lead details</a>",
      "LeadEditorId": 3,
      "LeadTypeId": 44,
      "LeadStateId": 83,
      "Deadline": "2022-03-10T10:48:11Z",
      "ExternalEmail": "f@ddd.com",
      "LeadNumber": "20220309001",
      "ActionName": "COMMENT_CREATE",
      "ActionText": "Create comment",
      "LeadTypeText": "Product advice",
      "LeadStateText": "Enquiry externally assigned",
      "LeadStateName": "ASSIGNED_EXT",
      "CreTs": "2024-11-28T09:53:28Z",
      "CreatorId": 3,
      "Creator": {
        "Id": 3,
        "Login": "jfritz",
        "FirstName": "Juliane",
        "LastName": "Fritz",
        "Organisation": "Digital Customer Experience",
        "Email": "JFritz@finstral.com",
        "Phone": "+39 0471296611",
        "LanguageCode": "en",
        "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/3?ts=1746195106",
        "Available": true,
        "Inactive": false,
        "NotificationsEnabled": false,
        "AppointmentMailEnabled": false,
        "ExternalMailCCEnabled": true,
        "CompletedMailEnabled": true,
        "LeadMailEnabled": false,
        "EnableReporting": true,
        "LastActivity": "2025-05-02T14:28:22Z"
      },
      "LeadEditor": {
        "Id": 3,
        "Login": "jfritz",
        "FirstName": "Juliane",
        "LastName": "Fritz",
        "Organisation": "Digital Customer Experience",
        "Email": "JFritz@finstral.com",
        "Phone": "+39 0471296611",
        "LanguageCode": "en",
        "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/3?ts=1746195106",
        "Available": true,
        "Inactive": false,
        "NotificationsEnabled": false,
        "AppointmentMailEnabled": false,
        "ExternalMailCCEnabled": true,
        "CompletedMailEnabled": true,
        "LeadMailEnabled": false,
        "EnableReporting": true,
        "LastActivity": "2025-05-02T14:28:22Z"
      },
      "Documents": [],
      "ComposerChanges": []
    },
    {
      "Id": 53511,
      "LeadId": 2187,
      "ActionId": 202,
      "Comment": "gg",
      "LeadEditorId": 3,
      "LeadTypeId": 44,
      "LeadStateId": 83,
      "Deadline": "2022-03-10T10:48:11Z",
      "ExternalEmail": "f@ddd.com",
      "LeadNumber": "20220309001",
      "ActionName": "LEAD_TAKEOVER",
      "ActionText": "Take over lead",
      "LeadTypeText": "Product advice",
      "LeadStateText": "Enquiry externally assigned",
      "LeadStateName": "ASSIGNED_EXT",
      "CreTs": "2024-11-20T08:17:38Z",
      "CreatorId": 3,
      "Creator": {
        "Id": 3,
        "Login": "jfritz",
        "FirstName": "Juliane",
        "LastName": "Fritz",
        "Organisation": "Digital Customer Experience",
        "Email": "JFritz@finstral.com",
        "Phone": "+39 0471296611",
        "LanguageCode": "en",
        "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/3?ts=1746195106",
        "Available": true,
        "Inactive": false,
        "NotificationsEnabled": false,
        "AppointmentMailEnabled": false,
        "ExternalMailCCEnabled": true,
        "CompletedMailEnabled": true,
        "LeadMailEnabled": false,
        "EnableReporting": true,
        "LastActivity": "2025-05-02T14:28:22Z"
      },
      "LeadEditor": {
        "Id": 3,
        "Login": "jfritz",
        "FirstName": "Juliane",
        "LastName": "Fritz",
        "Organisation": "Digital Customer Experience",
        "Email": "JFritz@finstral.com",
        "Phone": "+39 0471296611",
        "LanguageCode": "en",
        "AvatarURL": "https://staging-login.finstral.cloud/ProfileImage/3?ts=1746195106",
        "Available": true,
        "Inactive": false,
        "NotificationsEnabled": false,
        "AppointmentMailEnabled": false,
        "ExternalMailCCEnabled": true,
        "CompletedMailEnabled": true,
        "LeadMailEnabled": false,
        "EnableReporting": true,
        "LastActivity": "2025-05-02T14:28:22Z"
      },
      "Documents": [],
      "ComposerChanges": []
    }
  ];

  constructionTypes: any = [
    {
      "Id": 1,
      "Name": "SONSTIGE",
      "Inactive": false,
      "Description": "Other",
      "SortOrder": 3
    },
    {
      "Id": 2,
      "Name": "BAU",
      "Inactive": false,
      "Description": "New builds",
      "SortOrder": 2
    },
    {
      "Id": 3,
      "Name": "TAUSCH",
      "Inactive": false,
      "Description": "Replacement",
      "SortOrder": 1
    }
  ]

  getLeads( onlyMyLeads: boolean, openLeads: boolean, closedLeads: boolean, unreadLeads: boolean, pageInfo: LeadsPageInfo ): ObservableResult<LeadsData[]> {
    return ObservableResult.ofSuccess(this.leadsData);
  }

  getLeadsCount( onlyMyLeads: boolean, openLeads: boolean, closedLeads: boolean, unreadLeads: boolean, pageInfo: LeadsPageInfo ): ObservableResult<number> {
    return ObservableResult.ofSuccess(1);
  }

  queryLeads(request: LeadsQueryRequest): ObservableResult<LeadsData[]> {
    return ObservableResult.ofSuccess(this.leadsData);
  }

  queryLeadsCount(request: LeadsQueryRequest): ObservableResult<number> {
    return ObservableResult.ofSuccess(this.leadsData.length);
  }

  queryLeadsDownload(request: LeadsQueryRequest): ObservableResult<Blob> {
    return ObservableResult.ofSuccess(new Blob());
  }

  createLead( request: CreateLead ): ObservableResult<number> {
    return ObservableResult.ofSuccess(1);
  }

  getLeadById( leadId: number ): ObservableResult<LeadData> {
    return ObservableResult.ofSuccess(this.leadData);
  }

  getLeadWithContactById( contactId: number ): ObservableResult<LeadData[]> {
    return ObservableResult.ofSuccess([this.leadData]);
  }

  getLeadTypes(): ObservableResult<LeadType[]> {
    return ObservableResult.ofSuccess([this.leadType]);
  }

  getLeadStatus(): ObservableResult<LeadStatus[]> {
    return ObservableResult.ofSuccess([this.leadStatus]);
  }

  getLeadSources(): ObservableResult<LeadSources[]> {
    return ObservableResult.ofSuccess([this.leadSource]);
  }

  addLead( body: IContact ): ObservableResult<0> {
    return ObservableResult.ofSuccess();
  }

  getLeadFacts( id: number ): ObservableResult<FatcsStatus[]> {
    return ObservableResult.ofSuccess();
  }

  getLeadHistory( id: number ): ObservableResult<LeadsHistory[]> {
    return ObservableResult.ofSuccess(this.history);
  }

  getLeadComposerOffers( id: number ): ObservableResult<any[]> {
    return ObservableResult.ofSuccess([]);
  }

  getLeadDocuments( id: number ): ObservableResult<LeadDocumentsModel[]> {
    return ObservableResult.ofSuccess([]);
  }

  markAsRead( id: number ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  markMessageAsRead( id: number ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  markAsUnread( id: number ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  removeLeadDocument( id: number ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  markLeadDocument( id: number, favorite: boolean ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  downloadLeadDocument( id: number ): ObservableResult<Blob> {
    return ObservableResult.ofSuccess();
  }

  downloadLeadDocuments( id: number ): ObservableResult<Blob> {
    return ObservableResult.ofSuccess();
  }

  downloadLeadList(): ObservableResult<Blob> {
    return ObservableResult.ofSuccess();
  }

  downloadSearchedLeadByIds( leadIds: number[] ): ObservableResult<Blob> {
    return ObservableResult.ofSuccess();
  }

  downloadLead( id: number ): ObservableResult<Blob> {
    return ObservableResult.ofSuccess();
  }

  updateAddress( id: number, address: IAddressData ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  updateCommission( id: number, commission: { [key: string]: string } ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  deleteAddress( id: number ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  deleteLead( id: number ): ObservableResult<any> {
    return ObservableResult.ofSuccess();
  }

  getDuplicateLeads(): ObservableResult<any> {
    return ObservableResult.ofSuccess();
  }

  getDuplicateLeadById( leadId: number ): ObservableResult<CheckDuplicateContact> {
    return ObservableResult.ofSuccess();
  }

  solveDuplicates( leadId: number, body: SolveDuplicateContact ): ObservableResult<any> {
    return ObservableResult.ofSuccess();
  }

  getExtendedPropertiesByLeadId( leadId: number ): ObservableResult<ExtendedProperties> {
    return ObservableResult.ofSuccess(this.extendedProperties);
  }

  putExtendedPropertiesByLeadId( leadId: number, extendedProperties: ExtendedProperties ): ObservableResult<ExtendedProperties> {
    return ObservableResult.ofSuccess(this.extendedProperties);
  }

  getActionsById( leadId: number ): ObservableResult<LeadsDataAction[]> {
    return ObservableResult.ofSuccess([]);
  }

  getConstructionTypes(): ObservableResult<ConstructionTypes[]> {
    return ObservableResult.ofSuccess(this.constructionTypes);
  }


  importComposerLead(body: ImportComposerLeadRequest): ObservableResult<ImportComposerLeadResponse> {
    return ObservableResult.ofSuccess({ Number: "12345678" });
  }


  getEmailData( kkz: string ): ObservableResult<EmailData> {
    return ObservableResult.ofSuccess();
  }

  addLeadArticle( id: number, article: Articles ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  deleteLeadArticle( id: number, articleId: number ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  putLeadById( id: number, constructionTypeId: number ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  updateHistoryComment( historyId: number, newComment: string ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  deleteHistoryComment( historyId: number ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  getBrochures( locale?: string ): ObservableResult<Broschures[]> {
    return ObservableResult.ofSuccess(this.brochures);
  }

  getAusschreibungstextes( locale?: string ): ObservableResult<Ausschreibungstextes[]> {
    return ObservableResult.ofSuccess(this.ausschreibungs);
  }

  getCadDatens( locale?: string ): ObservableResult<CadDatens[]> {
    return ObservableResult.ofSuccess(this.cadData);
  }

  getMusters( locale?: string ): ObservableResult<Musters[]> {
    return ObservableResult.ofSuccess(this.muster);
  }

  getKeywords( leadId: number ): ObservableResult<Keyword[]> {
    return ObservableResult.ofSuccess([]);
  }

  getAllKeywords(): ObservableResult<string[]> {
    return ObservableResult.ofSuccess([]);
  }

  sendKeyWords( keywords: string[], leadId: number ): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  deleteKeywords( keywords: string[], leadId: number ): ObservableResult<string[]> {
    return ObservableResult.ofSuccess([]);
  }
}
